export default __webpack_public_path__ + "static/media/LAS0720.34I-37962_-22234_0.1d4bdda5.jpg";